// src/components/ResourceManager/Hardware/HardwareTableColumns.ts

import React from "react";
import { GenericTableColumn } from "@ui-components/Table/GenericTable";
import { Hardware } from "./request/request";

// Icons
import { ReactComponent as IconEye } from "../../../../shared/assets/Icons/Icon_Eye.svg";
import { ReactComponent as IconEdit } from "../../../../shared/assets/Icons/Icon_Edit.svg";
import { ReactComponent as IconDelete } from "../../../../shared/assets/Icons/Icon_Delete.svg";
import { ReactComponent as IconPort } from "../../../../shared/assets/Icons/IconPort.svg";

/**
 * Props que recibe getHardwareColumns para definir las acciones.
 */
interface HardwareColumnsProps {
	handleViewHardware: (hw: Hardware) => void;
	handleEditHardware: (hw: Hardware) => void;
	handleDeleteClick: (hw: Hardware) => void;
	/**
	 * Nuevo callback para abrir el modal de Ports.
	 * Si lo quieres opcional, pon “?:”.
	 */
	handlePortsClick: (hw: Hardware) => void;
}

/**
 * Retorna las columnas de la tabla para Hardware.
 */
export function getHardwareColumns({
	handleViewHardware,
	handleEditHardware,
	handleDeleteClick,
	handlePortsClick, // <-- Nuevo
}: HardwareColumnsProps): GenericTableColumn<Hardware>[] {
	return [
		{
			header: "ID",
			accessor: "id",
		},
		{
			header: "Datacenter ID",
			accessor: "datacenterId",
		},
		{
			header: "Hostname",
			accessor: "hostname",
		},
		{
			header: "Type",
			renderCell: (row: Hardware) => {
				if (row.typeHardware && typeof row.typeHardware === "object") {
					return row.typeHardware.name || "";
				}
				return "null";
			},
		},
		{
			header: "SubType",
			renderCell: (row: Hardware) => {
				if (row.subtypeHardware && typeof row.subtypeHardware === "object") {
					return row.subtypeHardware.name || "";
				}
				return "null";
			},
		},
		{
			header: "SerialNumber",
			accessor: "serialNumber",
		},
		{
			header: "Model",
			accessor: "model",
		},
		{
			header: "Vendor",
			accessor: "vendor",
		},

		{
			header: "Installed Date",
			accessor: "installedDate",
		},
		{
			header: "EndOfLifeDate",
			accessor: "endOfLifeDate",
		},
		{
			header: "Phase",
			accessor: "phase",
		},
		{
			header: "RackId",
			accessor: "rackId",
		},
		{
			header: "Rack Unit",
			accessor: "rackUnit",
		},
		{
			header: "Status",
			accessor: "status",
		},
		{
			header: "Actions",
			accessor: "id",
			renderCell: (row) => (
				<div className="flex items-center gap-2">
					{/* View */}
					<button
						className="
              flex items-center justify-center
              border border-semantic-border-secondary
              rounded
              text-semantic-text-secondary
              hover:bg-semantic-state-active
              w-10 h-10
            "
						onClick={() => handleViewHardware(row)}
					>
						<IconEye className="w-6 h-6" />
					</button>

					{/* Edit */}
					<button
						className="
              flex items-center justify-center
              border border-semantic-border-secondary
              rounded
              text-semantic-text-secondary
              hover:bg-semantic-state-active
              w-10 h-10
            "
						onClick={() => handleEditHardware(row)}
					>
						<IconEdit className="w-10 h-10" />
					</button>

					{/* Ports */}
					<button
						className="
    flex items-center justify-center
    border border-semantic-border-secondary
    rounded
    text-white
    w-14 h-10
    hover:bg-[var(--color-semantic-bg-brand-bold)]
  "
						onClick={() => handlePortsClick(row)}
					>
						<IconPort className="w-6 h-6" />
					</button>

					{/* Delete */}
					<button
						className="
              p-2
              border border-semantic-border-secondary
              rounded
              bg-red-50
              text-red-600
              hover:bg-red-100
            "
						onClick={() => handleDeleteClick(row)}
					>
						<IconDelete className="w-6 h-6" />
					</button>
				</div>
			),
		},
	];
}
